import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import { DropTarget } from "react-dnd"
import ContainerDimensions from "react-container-dimensions"
import { connect } from "../../utils"
import { DivEmptyContent } from "./styled"
import { RestApiProductList } from "../../../../restClient"
import { ProductCard } from "../../../components"
import { Flex } from "rebass"

const target = {
  drop(props, monitor, component) {
    if (!monitor.didDrop()) {
      props.layoutState.insertOrMoveItem(
        props.id,
        props.children.length,
        monitor.getItem()
      )
    }
  },
}
class EditLayout extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      values: [],
      productsContent: [],
    }
  }
  componentWillMount() {
    const { id, layoutState } = this.props

    const listID = JSON.parse(localStorage.getItem(`ProductListViewID${id}`))
    const { list } = layoutState.getItemJS(id).props.values
    let newValue = []
    if (Array.isArray(list)) {
      newValue = list
    }
    if (newValue.join() === listID) {
      const productlist = "ProductListView" + id
      const listProduct = JSON.parse(localStorage.getItem(productlist))
      this.setState({
        productsContent: listProduct,
        values: newValue,
      })
    } else {
      this.getProductList()
    }
  }

  componentWillUnmount() {
    this.unmounting = true
  }

  getProductList = () => {
    const { id, layoutState } = this.props
    const { list } = layoutState.getItemJS(id).props.values
    let newValue = []
    if (Array.isArray(list)) {
      newValue = list
    }

    //if (arraysEqual(newValue, this.state.values) === false) {}
    let params = newValue.join()
    const url = "/products?collections=" + params
    RestApiProductList(url)
      .then((response) => {
        return response.json()
      })
      .then((items) => {
        // this is for check unmounting components
        //console.log(this.unmounting);
        if (this.unmounting) {
          return
        }

        if (items && !items.messages) {
          let newItems = []
          for (var i = 0; i < items.length; ++i) {
            for (var j = 0; j < items[i].products.length; ++j)
              newItems.push(items[i].products[j])
          }
          this.setState({ productsContent: newItems, values: newValue })
        }
      })
      .catch((e) => {
        // console.error(e);
      })
  }

  renderEmptyList() {
    return (
      <div style={{ flex: 1, display: "flex" }}>
        <DivEmptyContent>Click here to add collection product</DivEmptyContent>
      </div>
    )
  }
  renderList(showPrice) {
    return (
      <ContainerDimensions>
        {({ width, height }) => {
          return (
            <Flex wrap pr={["0px", "0px", "8px"]} flex={["1"]}>
              {this.state.productsContent &&
                this.state.productsContent.map((product, index) => {
                  return (
                    <BoxCase key={`box${index}`} px={["8px"]} py={["8px"]}>
                      <ProductCard
                        product={product}
                        itemWidth={checkWidth(width)}
                        showPrice={showPrice}
                      />
                    </BoxCase>
                  )
                })}
            </Flex>
          )
        }}
      </ContainerDimensions>
    )
  }
  render() {
    const { id, connectDropTarget, layoutState } = this.props
    //type, children, isOverCurrent,, readOnly
    const { containerPadding, showPrice } = layoutState.getItemJS(
      id
    ).props.values
    return connectDropTarget(
      <div
        style={{
          boxSizing: "border-box",
          position: "relative",
          height: "100%",
          display: "flex",
          padding: containerPadding,
          flex: 1,
        }}
      >
        {this.state.productsContent && this.state.productsContent.length > 0
          ? this.renderList(showPrice)
          : this.renderEmptyList()}
      </div>
    )
  }
}

EditLayout.propTypes = {
  connectDropTarget: PropTypes.func.isRequired,
  isOverCurrent: PropTypes.bool,
  type: PropTypes.string,
  readOnly: PropTypes.bool,
  children: PropTypes.array,
  layoutState: PropTypes.object,
  id: PropTypes.string,
}

const LayoutContainer = DropTarget(
  "ProductListView",
  target,
  (conn, monitor) => ({
    connectDropTarget: conn.dropTarget(),
    isOverCurrent: monitor.isOver({ shallow: true }),
  })
)(EditLayout)

export default connect("layoutState", "readOnly")(LayoutContainer)

const BoxCase = Flex.extend`
  position: relative;
  overflow: hidden;

  @media screen and (min-width: 52em) {
    width: 25%;
  }
`

const checkWidth = (width) => {
  let result = width - 16
  if (width > 480 && width <= 600) {
    result = width / 2 - 18
  } else if (width > 600 && width <= 768) {
    result = width / 3 - 16
  } else if (width > 768) {
    result = width / 4 - 16
  }
  return result
}



// WEBPACK FOOTER //
// ./src/editor/layout/components/Layout/DnDProductList.js